/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ComponentBarChart from './ComponentBarChart';
import { RootState } from '../../../redux/rootState';
import { VesselReport } from '../types';
import BarChartTable from './barChartTable';
import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../helper';

function BarChartSection() {
  const { reportPdfResponse1, themePdfColor, tableContent } = useSelector((state:RootState) => state.reportPdfSliceReducer);
  const { BorderColor } = themePdfColor;

  const validGraphs = useMemo(() => reportPdfResponse1?.Comparison_Graphs?.filter((item) => item?.DefectComparison?.length > 0), [reportPdfResponse1]);

  return (
    <>
      {
      validGraphs?.map((details: VesselReport, index) => (
        <div key={index}>
          <div className="pageHeader">
            <div className="topHeader">
              <div className={`${index > 0 ? 'pt30 pb10' : ''}`}>
                {ReportPart1(tableContent, CombineReportEnum.COMBINE_DEFECT_GRAPH, PDFReportEnum.PDF_DEFECT_GRAPH, ' Comparison Graphs')}
                { index > 0
                && (
                <>
                  <br />
                  Defect Summary/Comparison - Page
                  {' '}
                  {index + 1}
                </>
                )}
              </div>
              <div className={`${index > 0 ? 'pt30 pb10' : ''}`}>{`S/N ${reportPdfResponse1?.JobOrderData?.SerialNumber}`}</div>
            </div>
            {index + 1 === 1 && <div className="underlineHeadingText textCenter">Defect Summary/Comparison</div>}
          </div>
          {/* {index + 1 === 1 && ( */}
          <div className="bayLengthHeader mb10">
            <div>{details?.IsRetestedVessel ? 'Comparison of Tests Performed' : 'Date Tested'}</div>
            <div>{details?.IsRetestedVessel ? `${details?.CurrentJobDate || ''} & ${details?.LastjobDate || 'Previous Date'}` : details?.CurrentJobDate || ''}</div>
          </div>
          {/* )} */}
          <div className="vesselNameHeader">
            <div>{`${details.VesselName} Defects`}</div>
          </div>
          <ComponentBarChart graphData={details} primaryColor={BorderColor} />
          <div className="mt20">
            <BarChartTable />
          </div>
          {/* { reportPdfResponse1.Comparison_Graphs.length > 0 && <div className="page-break" /> } */}
          {index < validGraphs.length - 1 && <div className="page-break" />}
        </div>
      ))
    }
    </>
  );
}

export default BarChartSection;
